import { render, staticRenderFns } from "./DashboardChartCard.vue?vue&type=template&id=7a138532&scoped=true"
import script from "./DashboardChartCard.vue?vue&type=script&lang=js"
export * from "./DashboardChartCard.vue?vue&type=script&lang=js"
import style0 from "./DashboardChartCard.vue?vue&type=style&index=0&id=7a138532&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a138532",
  null
  
)

export default component.exports